<template>
  <div class="zzzzzz" />
</template>

<script>
import Oidc from 'oidc-client';
import config from "@/params/config";
export default {
  name: 'Callback',
  created() {
    const self = this;
    if (window.localStorage.getItem('access_token')) {
      this.redirect()
      return
    }    
    new Oidc.UserManager({ response_mode: 'query' }).signinRedirectCallback().then((res) => {
      window.localStorage.setItem('access_token', res.access_token)
      window.localStorage.setItem('id_token', res.id_token)
      window.localStorage.setItem('refresh_token', res.refresh_token)
      this.redirect();
    }).catch(function(e) {
    })
  },
  methods: {
    redirect() {   
      const redirect = window.localStorage.getItem('redirect')
      window.localStorage.removeItem('redirect')
      if (redirect) {             
        this.$router.replace({ path: '/documents/TJmdreview' })
      } else {
          window.location.href=config.tjHost;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
